export type ApplicationErrorCode =
    | 'canvasUnavailable'
    | 'fileReadFailed'
    | 'imageLoadFailed'
    | 'invalidFile'
    | 'invalidScaleSteps'
    | 'invalidUrl'
    | 'modelLoadFailed'
    | 'referenceNotFound'
    | 'referenceRequired'
    | 'unsupportedProtocol'
    | 'unknownModel'
    | 'videoLoadFailed';

export class ApplicationError extends Error {
    readonly code: ApplicationErrorCode;
    readonly values: Readonly<Record<string, string | number>>;

    constructor(
        code: ApplicationErrorCode,
        values: Readonly<Record<string, string | number>> = {}
    ) {
        super(code);
        this.name = 'ApplicationError';
        this.code = code;
        this.values = values;
    }
}
